import { createUseStyles } from 'react-jss'

export default createUseStyles({
  sectionDescription: {
    marginBottom: '15px'
  }
})
